import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogType,
  PrimaryButton,
  DialogFooter,
  DefaultButton,
  TextField,
  ComboBox,
  IComboBoxOption,
  IComboBoxStyles,
} from '@fluentui/react';
import { dialogStyle, DialogFooterStyle } from '../styles/common/Dialog.style';
import { Stack, IStackProps, IStackStyles } from '@fluentui/react/lib/Stack';
import { apiServices } from '../../services/ApiServices';
import copy from 'copy-to-clipboard';
import AccessibleComboBox from '../AccessibleComboBox';

export interface ICloseListDialogProps {
  toggle: boolean;
  initial: boolean;
  closeComment(data: any, text: string, isToMe: boolean): void;
  displayTicketId?: string;
  isFromMonitor: boolean
}
const basicStyles: Partial<IComboBoxStyles> = {
  root: { backgroundColor: '#F3F2F1', border: 'none' },
  input: { backgroundColor: '#F3F2F1', '::after': { border: "none" } }
};
const columnProps: Partial<IStackProps> = {
  tokens: { childrenGap: 15 },
  styles: {
    root: { width: 'auto', borderBottom: 'solid 3px #6264A7', boxSizing: 'border-box', border: 'none' }
  }
};

const modalProps = {
  isBlocking: false,
  className: 'OpenModifyDialog',
  styles: { main: { padding: 20 } }
};

const CloseListDialog: React.FC<ICloseListDialogProps> = ({ toggle, initial, closeComment, displayTicketId, isFromMonitor }) => {
  const [close, setclose] = useState(true);
  const [text, setText] = useState('');
  const [userId, setUserId] = useState('');
  const [tickeAgentList, setTickeAgentList] = useState<IComboBoxOption[]>([]);
  const [isCopythis, setIsCopythis] = useState<any>(false);
  const [isBlur, setIsBlur] = useState<any>(false);
  const [activeData, setActiveData] = useState<any>('');


  const onRenderOption = (item: any) => {


    return (
      <span style={{ fontFamily: '' }}>
        <img></img> {item.text}
      </span>
    );
  };
  const dialogContentProps = {
    type: DialogType.normal,
    title: (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', overflow: 'hidden' }}>
        转交工单{' '}

      </div>
    ),
    closeButtonAriaLabel: '关闭'
  };

  // 获取可转交列表
  const getTicketableAgent = async () => {
    let UserId = JSON.parse(sessionStorage.getItem('user') || '')?.userId
    setUserId(UserId)
    let res = await apiServices.getTicketableAgent();
    if (res && res.result) {
      let datalist: IComboBoxOption[] = res.result.map((item: any, index: number) => {
        return {
          key: index,
          text: item.displayName,
          data: item
        };
      })
      if (!isFromMonitor) {
        datalist = datalist.filter((item: any) => {
          return !UserId || item.data.userId !== UserId
        });
      }
      setTickeAgentList(datalist);
    }
  };

  useEffect(() => {
    getTicketableAgent()
    !initial && setclose(false);
  }, [toggle]);
  const ComboBoxChange = (e: any, item: any) => {
    if (item) {
      setActiveData(item);
    }
  };
  return (
    <Dialog
      // 关闭工单弹窗
      className={dialogStyle}
      hidden={close}
      onDismiss={() => { setclose(true) }}
      dialogContentProps={dialogContentProps}
      maxWidth={'80%'}
      minWidth={'75%'}
      styles={{ main: { width: "75%", height: "80%", '.ms-Modal-scrollableContent>:first-child': { height: "100%", '.ms-Dialog-inner': { height: "90%", display: 'flex', justifyContent: "space-between", flexDirection: "column" } } } }}
      modalProps={modalProps}
    >
      <div >
        <Stack>
        <AccessibleComboBox
            id= {"transferListDialog-accessible-comboBox"}
            component={ComboBox}
            defaultSelectedKey="Calibri"
            label="转交人"
            allowFreeform
            autoComplete="on"
            placeholder={tickeAgentList.length > 0 ? '请选择转交人' : '暂无可转交人'}
            options={tickeAgentList}
            onRenderOption={onRenderOption}
            styles={basicStyles}
            onChange={ComboBoxChange}
            onBlur={() => { setIsBlur(true) }}
            onFocus={() => { setIsBlur(false) }}
          />
          {isBlur && !activeData &&
            <span style={{ color: "#C4314B", marginTop: "-1px", borderTop: "solid 2px", zIndex: 1 }}>必填</span>
          }
        </Stack>
        <Stack {...columnProps}>
          <TextField
            label="留言"
            // underlined
            borderless={true}
            style={{ backgroundColor: '#F3F2F1', boxSizing: 'border-box' }}
            placeholder="简单给同事留个言吧！（最少10个字）"
            multiline
            rows={5}
            // autoAdjustHeight={true}
            onChange={(e: any) => {
              setText(e.target.value);
            }}
          />
          {text.length > 200 && <span style={{ color: "#C4314B", marginTop: "0px", borderTop: "solid" }}>最多200字</span>}
          {text.length < 10 && text.length !== 0 && <span style={{ color: "#C4314B", marginTop: "0px", borderTop: "solid" }}>最少10字</span>}
        </Stack>
      </div>
      <DialogFooter className={DialogFooterStyle}>
        <DefaultButton
          text="取消"
          onClick={() => {
            setclose(true);
            setIsCopythis(false);
            setActiveData('');
            setText('');
          }}
        />

        <PrimaryButton
          text="确定"
          onClick={() => {
            setclose(true);
            closeComment(activeData, text, userId === activeData.data.userId);
            setIsCopythis(false);
            setActiveData('');
            setText('');
          }}
          disabled={text.length >= 10 && activeData ? false : true}
        />
      </DialogFooter>
    </Dialog>
  );
};
export default CloseListDialog;
